export default {"src":"/_next/static/media/radio-inactive.0bf98248.svg","height":16,"width":16};